module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page07"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "contentsHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Contents")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ack_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "#/ack01#ack01"
    }
  }, [_vm._v("Acknowledgements")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "map_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "#/map01#map01"
    }
  }, [_vm._v("Map")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "int_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "#/int01#int01"
    }
  }, [_vm._v("Introduction")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#ch01"
    }
  }, [_vm._v("CHAPTER ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#ch01"
    }
  }, [_vm._v("You can check out any time you like, "), _c('br'), _vm._v("but you can never leave")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plaything for a king")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Birth of the Leopard")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dizzy worms")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Living above the shop")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A nation on Low Batt")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page08"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Never naked")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The importance of being elegant")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I get by with a little help from my friends")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A folly in the jungle")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The night the pink champagne went flat")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWELVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Inseparable Four")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nappies on the floor")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOURTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ill-gotten gains")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "epi_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/epi01#epi01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "glo_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/glo01#glo01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "bib_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/bib01#bib01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ind_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/ind01#ind01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Searchable Terms")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ata_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/ata01#ata01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "cop_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/cop01#cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    attrs: {
      "href": "#/atp01#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0